import * as React from 'react';
import {Formik, Form, FieldArray, FastField, ErrorMessage} from 'formik';
import {
    Box,
    Button,
    MenuItem,
    Container,
    Accordion,
    AccordionSummary,
    AccordionDetails, Typography, Icon, Card, CardContent, FormControlLabel, FormControl, FormHelperText
} from '@material-ui/core';
import { TextField } from 'formik-material-ui';
import {
    KeyboardDatePicker ,
} from 'formik-material-ui-pickers';
import * as Yup from "yup";
import {useContext, useEffect, useState} from "react";
import AppStore from "../AppStore";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {FormattedMessage} from "react-intl";
import {makeStyles} from "@material-ui/core/styles";
import Loader from "../components/Loader";
import UploadComponent from "../components/UploadComponent";
import {Alert} from "@material-ui/lab";
import Checkbox from '@material-ui/core/Checkbox';
import { useHistory } from 'react-router-dom';
import {Error} from "@material-ui/icons";
import {CountryAutocomplete} from "../components/CountryAutocomplete";
import {PhoneNumber} from "../components/PhoneNumber";

const gender = [
    ["M", <FormattedMessage id="app.checkin.gender.male"/>],
    ["F", <FormattedMessage id="app.checkin.gender.female"/>],
    ["O", <FormattedMessage id="app.checkin.gender.other"/>]
];

const documentTypes = [
    ["DNI", "DNI"],
    ["PASS", <FormattedMessage id="app.checkin.document.pass"/>],
    ["CI", <FormattedMessage id="app.checkin.document.ci"/>],
    ["OTHER", <FormattedMessage id="app.checkin.document.other"/>]
];

let formik = {
    validateOnChange: false,
    validateOnBlur: true,
    initialValues: {
        guests : [],
    },
    validationSchema: Yup.object().shape({
        guests: Yup.array()
            .of(
                Yup.object().shape({
                    name: Yup.string()
                        .required(<FormattedMessage id="app.required_field"/>),
                    surname: Yup.string()
                        .required(<FormattedMessage id="app.required_field"/>),
                    gender: Yup.string()
                        .required(<FormattedMessage id="app.required_field"/>),
                    nationality: Yup.string()
                        .required(<FormattedMessage id="app.required_field"/>),
                    phone: Yup.string()
                        .min(10, <FormattedMessage id="app.invalid_field"/>)
                        .test('not-null-phone', <FormattedMessage id="app.required_field"/>, function(currentValue) {
                            return this.options.index !== 0 || currentValue;
                        }),
                    email: Yup.string()
                        .email(<FormattedMessage id="app.invalid_field"/>)
                        .test('not-null-email', <FormattedMessage id="app.required_field"/>, function(currentValue) {
                            return this.options.index !== 0 || currentValue;
                        }),
                    documentType: Yup.string()
                        .required(<FormattedMessage id="app.required_field"/>),
                    documentNumber: Yup.string()
                        .required(<FormattedMessage id="app.required_field"/>)
                        .when('documentType', {
                            is: 'DNI',
                            then: Yup.string()
                                .matches(/^[0-9]+$/, <FormattedMessage id="app.numeric_field"/>)
                        }),
                    birthDate: Yup.date()
                        .required(<FormattedMessage id="app.required_field"/>)
                        .nullable(),
                    files: Yup.array()
                        .when('documentType', {
                            is: 'PASS',
                            then: Yup.array()
                                .min(1, <FormattedMessage id="app.checkin.photo-required"/>),
                            otherwise: Yup.array()
                                .min(2, <FormattedMessage id="app.checkin.photo-required"/>)
                        })
                })
            )
    })
};

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        //flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        marginLeft: theme.spacing(1),
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
        textTransform: "lowercase"
    },
    guestErrors: {
        marginRight: theme.spacing(1),
        fontSize: theme.typography.pxToRem(14),
        color: 'red'
    }
}));

let contract;
let covid19;

export default function CheckinPage()
{
    const appStore = useContext(AppStore);
    const history = useHistory();

    const [loading, setLoading] = useState(true);
    const [step, setStep] = useState('data');
    const [formData, setFormData] = useState(false);

    const [submit, setSubmit] = useState({
        'submitting' : false,
        'error' : ''
    });

    function createPaxValues(paxType) {
        return {
            name : '',
            surname : '',
            gender: '',
            nationality: '',
            phone: '',
            email: '',
            documentType: '',
            documentNumber: '',
            birthDate: null,

            files: [],
            _paxType: paxType,
        }
    }

    useEffect(() => {
        if (loading) {
            appStore.getBookingData( (bookingData) => {
                // Por si accede directo a la pantalla de checkin
                if (bookingData.status !== 12 ) {
                    history.replace( {pathname: `/${appStore.tenant}/${appStore.resort}/home`} );
                    return;
                }

                formik.initialValues.guests = []; // Porque al entrar por segunda vez, sigue acumulando

                for (let i=1; i<=bookingData['adults']; i++) {
                    formik.initialValues.guests.push(createPaxValues(
                        i===1 ? 'holder' : 'adult'
                    ))
                }
                for (let i=1; i<=bookingData['children']; i++) {
                    formik.initialValues.guests.push(createPaxValues(
                        'children'
                    ))
                }

                // Usamos los datos que vinen en la reserva
                // Lo que viene en blanco no lo seteamos ya que en algunos casos por ser null o blank, da error
                for (let i=0; i<bookingData['guests'].length; i++) {
                    const guest = bookingData['guests'][i];
                    for (let fld in guest) {
                        if (guest.hasOwnProperty(fld)) {
                            if (guest[fld]) {
                                formik.initialValues.guests[i][fld] = guest[fld];
                            }
                        }
                    }
                }

                contract = bookingData['contract'];
                covid19 = bookingData['covid19'];

                setLoading(false);
            } );
        }
    });


    const onSubmitData = (values) => {
        //console.log(JSON.stringify(values, null, 2));
        setSubmit({
            'submitting' : false,
            'error' : ''
        })
        setFormData(values);
        setStep('contract')
    };

    const onSubmitContract = () => {
        setSubmit({'submitting' : true, 'error' : ''});

        const requestOptions = {
            method: 'PUT',
            body: JSON.stringify(formData)
        };

        return fetch(appStore.getApiUriPrefix() + '/bookings/' + appStore.getCredentials().bookingCode, requestOptions)
            .then(function(response) {
                if (response.status === 201)
                    return response.json();
                else
                    throw Error(response.statusText);
            })
            .then(function(json) {
                if (json['redirectUrl']) {
                    window.location = json['redirectUrl'];
                }
                else {
                    history.replace( {pathname: `/${appStore.tenant}/${appStore.resort}/home`} );
                }
            })
            .catch(function() {
                setSubmit({'submitting' : false, 'error' : "Se ha producido un error. Revise la conexión a internet y vuelva a intentarlo"});
            });
    };

    const showDataForm = () => {
        setStep('data')
    }

    return (
        <div>
            {loading &&
            <Loader />
            }

            {!loading &&
            <Container maxWidth="sm" style={{margin: 0, padding: 0}}>
                <Box hidden={step !== 'data'}>
                    <DataForm onSubmit={onSubmitData}/>
                </Box>
                <Box hidden={step !== 'contract'}>
                    <ContractForm onSubmit={onSubmitContract} onBack={showDataForm} submit={submit} />
                </Box>
            </Container>
            }
        </div>
    );
}

function ContractForm( {onSubmit, onBack, submit} )
{
    const appStore = useContext(AppStore);
    const [checked1, setChecked1] = React.useState(false);
    const [checked2, setChecked2] = React.useState(false);

    const handleChange1 = (event) => {
        setChecked1(event.target.checked);
    };

    const handleChange2 = (event) => {
        setChecked2(event.target.checked);
    };

    return (
        <>
            <Box>
                <Card>
                    <CardContent>
                        <Typography gutterBottom variant="h6" component="h2">
                            <FormattedMessage id="app.checkin.contract"/>
                        </Typography>
                        <Typography variant="body2" color="textSecondary" align={"justify"} dangerouslySetInnerHTML={{
                            __html: contract[appStore.language] ?? contract['es'] ?? '-'
                        }} />
                    </CardContent>
                </Card>
            </Box>
            <Box mt={2}>
                <Card>
                    <CardContent>
                        <Typography gutterBottom variant="h6" component="h2">
                            Covid 19
                        </Typography>
                        <Typography variant="body2" color="textSecondary" align={"justify"} dangerouslySetInnerHTML={{
                            __html: covid19[appStore.language] ?? covid19['es'] ?? '-'
                        }} />
                    </CardContent>
                </Card>
            </Box>

            <Box mt={1}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checked1}
                            onChange={handleChange1}
                            color="primary"
                        />
                    }
                    label={<FormattedMessage id="app.checkin.accept-contract"/>}
                />
            </Box>
            <Box>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checked2}
                            onChange={handleChange2}
                            color="primary"
                        />
                    }
                    label={<FormattedMessage id="app.checkin.accept-covid-19"/>}
                />
            </Box>

            {submit.error &&
            <Box mt={2}>
                <Alert severity="error">
                    {submit.error}
                </Alert>
            </Box>
            }

            <Box mt={2}>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!checked1 || !checked2 || submit.submitting}
                    fullWidth
                    onClick={onSubmit}
                >
                    <FormattedMessage id="app.checkin.end-checkin"/>
                </Button>
            </Box>
            <Box mt={1}>
                <Button
                    variant="outlined"
                    color="primary"
                    fullWidth
                    onClick={onBack}
                >
                    <FormattedMessage id="app.checkin.back"/>
                </Button>
            </Box>
        </>
    )
}

function DataForm(props)
{
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(''); // Poner panel0 para expandir el primero

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    const onSubmit = (values, { setSubmitting }) => {
        setTimeout(() => {
            setSubmitting(false);
            //alert(JSON.stringify(values, null, 2));
            props.onSubmit.call(this, values);
        }, 500);
    }

    return (
        <>
            <Box ml={1} mb={2}>
                <Typography color="textSecondary" variant="button">
                    <FormattedMessage id="app.checkin.please-enter-data"/>
                </Typography>
            </Box>
            <Formik
                {...formik}
                onSubmit={onSubmit}
            >
                {({ submitForm, isSubmitting, values, isValid, submitCount }) => (
                    <Form>
                        <FieldArray
                            name="guests"
                            render={() => (
                                <div className={classes.root}>
                                    {values.guests.map((guest, index) => (
                                        <Accordion
                                            key={index}
                                            expanded={expanded === `panel${index}`}
                                            onChange={handleChange(`panel${index}`)}
                                        >
                                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                {submitCount > 0 &&
                                                <ErrorMessage name={`guests[${index}]`}>
                                                    {() =>
                                                        <Typography className={classes.guestErrors}>
                                                            <Icon>error_outline</Icon>
                                                        </Typography>
                                                    }
                                                </ErrorMessage>
                                                }
                                                <Typography className={classes.heading}>
                                                    {guest.name
                                                        ? (guest.name + ' ' + guest.surname)
                                                        : (guest._paxType === 'holder'
                                                                ? <FormattedMessage id="app.checkin.holder"/>
                                                                : <FormattedMessage id="app.checkin.accompany"/>
                                                        )
                                                    }
                                                </Typography>
                                                {!guest.name &&
                                                <Typography className={classes.secondaryHeading}>
                                                    {guest._paxType === 'children'
                                                        ? <FormattedMessage id="app.checkin.children"/>
                                                        : <FormattedMessage id="app.checkin.adult"/>
                                                    }
                                                </Typography>
                                                }
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <GuestForm index={index} valuesGuest={guest} />
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                                </div>
                            )}
                        />

                        <Box mt={3}>
                            {!isValid && submitCount>0 &&
                            <Alert severity="error">
                                Controle que todos los datos sean correctos
                            </Alert>
                            }
                        </Box>

                        <Box mt={2}>

                            <Button
                                variant="contained"
                                color="primary"
                                disabled={isSubmitting}
                                onClick={submitForm}
                                fullWidth
                            >
                                <FormattedMessage id="app.checkin.next"/>
                            </Button>
                        </Box>

                        {/*{<Debug values={values} />}*/}
                    </Form>
                )}
            </Formik>
        </>
    )
}

function GuestForm({ index, valuesGuest })
{
    const prefix = `guests[${index}].`;
    const appStore = React.useContext(AppStore);

    const allowedDocumentTypes = appStore.getResortData()['options']['documentTypes'] ?? [];
    if (allowedDocumentTypes.length > 0) {
        for (let i=0; i<documentTypes.length; i++) {
            const code = documentTypes[i][0];
            if (allowedDocumentTypes.indexOf(code) === -1) {
                documentTypes.splice(i, 1);
            }
        }
    }


    return (
        <Box width="100%">
            <Box width="100%">
                <FastField
                    component={TextField}
                    name={prefix + 'name'}
                    label={<FormattedMessage id="app.checkin.guest-name"/>}

                    required
                    variant={"outlined"}
                    fullWidth
                    margin={"normal"}
                />
            </Box>
            <Box width="100%">
                <FastField
                    component={TextField}
                    name={prefix + 'surname'}
                    label={<FormattedMessage id="app.checkin.guest-surname"/>}

                    required
                    variant={"outlined"}
                    fullWidth
                    margin={"normal"}
                />
            </Box>
            <Box width="100%">
                <FastField
                    component={TextField}
                    select
                    name={prefix + 'gender'}
                    label={<FormattedMessage id="app.checkin.guest-gender"/>}

                    required
                    variant={"outlined"}
                    fullWidth
                    margin={"normal"}
                >
                    {gender.map(option => (
                        <MenuItem key={option[0]} value={option[0]}>
                            {option[1]}
                        </MenuItem>
                    ))}
                </FastField>
            </Box>
            <Box width="100%">
                <CountryAutocomplete
                    name={prefix + 'nationality'}
                    label={<FormattedMessage id="app.checkin.guest-nationality"/>}
                    required
                >
                </CountryAutocomplete>
            </Box>
            <Box width="100%">
                <FastField
                    component={TextField}
                    select
                    name={prefix + 'documentType'}
                    label={<FormattedMessage id="app.checkin.guest-document-type"/>}

                    required
                    variant={"outlined"}
                    fullWidth
                    margin={"normal"}
                >
                    {documentTypes.map(option => (
                        <MenuItem key={option[0]} value={option[0]}>
                            {option[1]}
                        </MenuItem>
                    ))}
                </FastField>
            </Box>
            <Box width="100%">
                <FastField
                    component={TextField}
                    name={prefix + 'documentNumber'}
                    label={<FormattedMessage id="app.checkin.guest-document-no"/>}

                    required
                    variant={"outlined"}
                    fullWidth
                    margin={"normal"}
                />
            </Box>
            <Box width="100%">
                <FastField
                    component={KeyboardDatePicker }
                    name={prefix + 'birthDate'}
                    label={<FormattedMessage id="app.checkin.guest-birthdate"/>}

                    required
                    inputVariant={"outlined"}
                    fullWidth
                    disableFuture
                    openTo="year"
                    format="DD / MM / YYYY"
                    placeholder="dd / mm / yyyy"
                    views={["year", "month", "date"]}
                    margin={"normal"}
                />
            </Box>

            {index===0 &&
            <>
                <Box width="100%">
                    <PhoneNumber
                        name={prefix + 'phone'}
                        label={<FormattedMessage id="app.checkin.guest-phone-number"/>}
                        defaultCountry={
                            valuesGuest.phone
                                ? false
                                : (String(valuesGuest.nationality ? valuesGuest.nationality : 'ar').toLowerCase())
                        }
                    >
                    </PhoneNumber>
                </Box>
                <Box width="100%">
                    <FastField
                        component={TextField}
                        name={prefix + 'email'}
                        label={<FormattedMessage id="app.checkin.guest-email"/>}

                        required
                        variant={"outlined"}
                        fullWidth
                        margin={"normal"}
                    />
                </Box>
            </>
            }

            {valuesGuest['documentType'] &&
                <Box mt={2}>
                        <FormControl fullWidth>
                            {valuesGuest['documentType'] === 'PASS' &&
                                <Box>
                                    <UploadComponent
                                        formFiles={valuesGuest['files']}
                                        label={"Frente"}
                                    />
                                </Box>
                            }
                            {valuesGuest['documentType'] !== 'PASS' &&
                                <>
                                <Box>
                                    <UploadComponent
                                        formFiles={valuesGuest['files']}
                                        label={"Frente"}
                                    />
                                </Box>
                                <Box mt={2}>
                                    <UploadComponent
                                        formFiles={valuesGuest['files']}
                                        label={"Reverso"}
                                    />
                                </Box>
                                </>
                            }
                            <Box px={2}>
                                <FormHelperText error>
                                    <ErrorMessage name={prefix + 'files'} />
                                </FormHelperText>
                            </Box>
                        </FormControl>

                    <Box mt={1}>
                        <Typography color="textSecondary" variant="caption">
                            <FormattedMessage id="app.checkin.open-camera"/>
                        </Typography>
                    </Box>
                </Box>
            }
        </Box>
    )
}
